import { React, useState, useEffect } from "react";

const PopUpOneCardmeterResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let oneMeterPlayerACards = [];
    let oneMeterPlayerBCards = [];
    let oneMeterPlayers = [];
    let oneMeterWinner = "";

    if (marketType == 54) {
        oneMeterPlayerACards = resultData.ac1
            ? resultData.ac1.split(",")
            : [];
        oneMeterPlayerBCards = resultData.ac2
            ? resultData.ac2.split(",")
            : [];
        oneMeterPlayers = [
            "Player A",
            "Player B",
        ];
        oneMeterWinner = resultData.resultTxt || "";
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="one-meter-card" style={{ display: marketType == 54 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item">
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>
                                                Player A
                                            </span>
                                        </b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        justifyContent: "center",
                                                        padding: "3px"
                                                    }}
                                                >
                                                    {oneMeterPlayerACards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>
                                                Player B
                                            </span>
                                        </b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        justifyContent: "center",
                                                        padding: "3px"
                                                    }}
                                                >
                                                    {oneMeterPlayerBCards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        {oneMeterPlayers.map((player, index) => {
                                            const winner = player === oneMeterWinner;
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                        marginBottom: "18px"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "22px",
                                                            fontWeight: "700"
                                                        }}
                                                    >
                                                        {player}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpOneCardmeterResults;

